module.exports = __webpack_public_path__ + "img/review-3.bdd029b3.png";